import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=5b44d53a"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b44d53a')) {
      api.createRecord('5b44d53a', component.options)
    } else {
      api.reload('5b44d53a', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=5b44d53a", function () {
      api.rerender('5b44d53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/BaseCheckbox.vue"
export default component.exports